{
  "Empty": "비어 있음"
}
